<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div>
      <div>
        <p class="navadno-besedilo">
          Na vaš mobilni telefon lahko pošljemo nastavitven SMS, v katerem boste prejeli nastavitve za
          APN točko. Izbirate lahko med možnostmi internet + MMS ali vsako posebej.
        </p>
      </div>
      <div style="padding-top: 10px">
        <p class="navadno-besedilo">
          <b v-if="kontaktniPodatki !== null">
            Če ne boste prejeli SMS-a z nastavitvami APN točke,
            nas pokličite na {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }},
          </b>
          kjer vam bodo svetovalci pomagali ročno nastaviti ustrezne nastavitve. <br/>
          Več na spletni strani
          <a :href="povezavaNastavitevPodatkovnihMmsParametrov" class="primarna-barva"
             target="_blank">
            {{ this.povezavaNastavitevPodatkovnihMmsParametrov }}
          </a>
        </p>
      </div>
    </div>
    <div style="padding-top: 20px;">
      <el-form :label-position="formaOrientacija">
        <el-form-item label="Izberi tip nastavitvenega SMSa">
          <el-select v-model="tipNastavitveniSms" :placeholder="this.tipNastavitveniSmsLista[0]"
                     class="velikost-izbrane-nastavitve-sms">
            <el-option
              v-for="tip in tipNastavitveniSmsLista"
              :label="tip"
              :key="tip"
              :value="tip">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="padding-top: 1px">
        <el-button type="primary" @click="NastaviApnTocko" class="gumb-potrdi" :disabled="tipNastavitveniSms===''">
          POŠLJI NASTAVITVEN SMS
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../../../assets/js/Povezave/povezave'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'
import {Checkbox, Button, Select, Option, Input, Collapse, CollapseItem, Tooltip} from 'element-ui'
import {KontaktniPodatkiEnum} from '../../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'

export default {
  name: 'NastavitevApnTock',
  mixins: [PrikazVsebine],
  data () {
    return {
      tipNastavitveniSmsLista: ['Internet + MMS', 'Internet', 'MMS'],
      formaOrientacija: 'left',
      tipNastavitveniSms: '',
      povezavaNastavitevPodatkovnihMmsParametrov: '',
      mejnaSirina: 1200,
      kontaktniPodatki: ''
    }
  },
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [Tooltip.name]: Tooltip,
    [CollapseItem.name]: CollapseItem
  },
  props: {
    izbranPrikljucek: null,
    izbranaTelefonska: null
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    }
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.clientAgent = new ClientAgent()
    this.povezavaNastavitevPodatkovnihMmsParametrov = povezave.BASE_URL_NASTAVITEV_PODATKOVNIH_MMS_PARAMETROV
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    NastaviApnTocko () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let dataSet = ''
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        if (this.tipNastavitveniSms === 'MMS') {
          dataSet = 'mms'
        } else if (this.tipNastavitveniSms === 'Internet') {
          dataSet = 'data'
        } else if (this.tipNastavitveniSms === 'Internet + MMS') {
          dataSet = 'set'
        }
        param.push('tip=' + dataSet)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/nastavitveniSMS',
          param,
          dataSet,
          'SetNastaviApnTocko',
          'ErrNastaviApnTocko')
      }
    },
    SetNastaviApnTocko () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno poslan nastavitveni SMS.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNastaviApnTocko (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped
       src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/NastavitevApnTock.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/NastavitevApnTock.vue